import { render } from "./DailyMenuAdmin.vue?vue&type=template&id=c2e1d1c4&scoped=true"
import script from "./DailyMenuAdmin.vue?vue&type=script&lang=js"
export * from "./DailyMenuAdmin.vue?vue&type=script&lang=js"

import "./DailyMenuAdmin.vue?vue&type=style&index=0&id=c2e1d1c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2e1d1c4"]])

export default __exports__